// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel"};


//////////////////
// WEBPACK FOOTER
// ./components/faq/_FAQBox.scss
// module id = ./components/faq/_FAQBox.scss
// module chunks = 1